import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import * as moment from "moment";
import './TicketReport.css';

// "Last updated" badge showing how fresh the Service Portal report data is.
class LastRefresh extends Component {
    constructor(props) {
        super(props);
        this.state = {
            last_refresh: ''
        };
    }

    componentDidMount() {
        this.get_last_refresh();
    }

    get_last_refresh() {
        axios.get(config.get('API_URL') + '/ServiceReport/last_refresh', {
            headers: {
                Authorization: localStorage.usertoken
            },
            params: {
                task_identifier: this.props.task_identifier
            }
        }).then(response => {
            if (response.data && response.data.last_refresh) {
                this.setState({last_refresh: response.data.last_refresh});
            }
        }).catch(err => {
            console.log(err);
        });
    }

    render() {
        if (this.state.last_refresh === '') {
            return null;
        }
        return (
            <div className="service-sync-con">
                <span className="dash-data-sync-sp">
                    <span>Last updated: <b>{moment(this.state.last_refresh).format('D MMM YYYY')}</b></span>
                </span>
            </div>
        );
    }
}

LastRefresh.defaultProps = {
    task_identifier: 'load-service-portal-data'
};

export default LastRefresh;
